import { ProjectService as OvermapProjectService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class ProjectService extends OvermapProjectService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
